import { Link } from "react-router-dom";
import { RuleOrnament } from "../../components/Decorations";

const projectAreas = [
  {
    number: "01",
    partners: "GESTÃO E ATENDIMENTO",
    title: "Gestão empresarial e social",
    description: "Integração de gestão financeira, folha de pagamento e RH com cadastros, atendimento e acompanhamento de projetos. Automação de rotinas, conciliação e relatórios para apoiar a operação e a prestação de contas.",
    capabilities: "BaaS · Folha de pagamento · RH · Relatórios",
  },
  {
    number: "02",
    partners: "CULTURA E PATRIMÔNIO",
    title: "Cultura, acervos e audiovisual",
    description: "Digitalização, catalogação e organização de acervos, conectadas à gestão de espaços culturais, reservas, eventos e atendimento. Infraestrutura audiovisual, streaming e experiências interativas para ampliar o acesso às obras e à formação.",
    capabilities: "Acervos digitais · Gestão de espaços · Streaming",
  },
  {
    number: "03",
    partners: "ESPORTES E FORMAÇÃO",
    title: "Esports e educação tecnológica",
    description: "Plataformas para atletas, filiações, torneios e rankings, integradas à operação de arenas e centros de treinamento. Implantação de redes, computadores e audiovisual, com ensino digital, certificação e transmissão de eventos.",
    capabilities: "Arenas · Torneios · EAD · Certificação",
  },
  {
    number: "04",
    partners: "TERRITÓRIO E DOCUMENTAÇÃO",
    title: "Território e gestão documental",
    description: "Plataformas para cadastros territoriais, mapas e georreferenciamento, com aplicativos de campo e acompanhamento de processos de REURB. Portais de atendimento, fluxos documentais e indicadores de produtividade para apoiar equipes e beneficiários.",
    capabilities: "Georreferenciamento · Aplicativos de campo · Workflows",
  },
  {
    number: "05",
    partners: "CIÊNCIA E SAÚDE",
    title: "Saúde, laboratórios e pesquisa",
    description: "Sistemas laboratoriais e rastreabilidade de amostras, apoiados por infraestrutura de dados, redes e automação de rotinas científicas. Ambientes de ensino híbrido, audiovisual e simulação para formação técnica e pesquisa aplicada.",
    capabilities: "LIMS · Automação · Dados · Pesquisa aplicada",
  },
];

export function HomePage() {
  return (
    <div className="institutional-home">
      <section className="institutional-hero" aria-labelledby="home-heading">
        <div className="institutional-hero__content">
          <span className="hero__eyebrow reveal">DataSci · Tecnologia e conhecimento</span>
          <h1 id="home-heading" className="reveal reveal-2">Inteligência para gerir.<br /><em>Conhecimento para transformar.</em></h1>
          <p className="hero__lead reveal reveal-3">
            BaaS, gestão financeira empresarial, folha de pagamento, RH e acervos de obras.
            Conectamos software, dados e educação às necessidades de cada instituição.
          </p>
          <div className="hero__actions reveal reveal-4">
            <a href="#solucoes" className="btn">Conheça nossas soluções <span aria-hidden="true">↗</span></a>
            <Link to="/legal/contato" className="btn btn-secondary">Fale com a DataSci</Link>
          </div>
        </div>
        <aside className="institutional-hero__panel reveal reveal-3" aria-label="Áreas de atuação: Dados e IA, Integração digital, Formação técnica, Curadoria editorial, Gestão empresarial e Software sob demanda">
          <span className="portfolio-label">Da informação à operação</span>
          <div className="institutional-hero__diagram" aria-hidden="true">
            <span className="institutional-hero__orbit" />
            <span className="institutional-hero__orbit institutional-hero__orbit--inner" />
            <span className="institutional-hero__core">DataSci</span>
            <span className="institutional-hero__node institutional-hero__node--top">Dados e IA</span>
            <span className="institutional-hero__node institutional-hero__node--left">Integração digital</span>
            <span className="institutional-hero__node institutional-hero__node--right">Formação técnica</span>
            <span className="institutional-hero__node institutional-hero__node--lower-left">Curadoria e acervos</span>
            <span className="institutional-hero__node institutional-hero__node--lower-right">Gestão empresarial</span>
            <span className="institutional-hero__node institutional-hero__node--bottom">Software sob demanda</span>
          </div>
          <p>Soluções integradas.<br /><strong>Impacto em diferentes setores.</strong></p>
        </aside>
      </section>

      <section id="solucoes" className="portfolio-section" aria-labelledby="solutions-heading">
        <div className="section-heading">
          <div><span className="portfolio-label">O que fazemos</span><h2 id="solutions-heading">Tecnologia a serviço da gestão.</h2></div>
        </div>
        <div className="solution-grid">
          <article className="solution-card"><span className="portfolio-index">01 / GESTÃO</span><h3>BaaS e gestão empresarial</h3><p>Gestão financeira, folha de pagamento e rotinas de RH em sistemas integrados para empresas.</p></article>
          <article className="solution-card"><span className="portfolio-index">02 / CONHECIMENTO</span><h3>Acervos e conteúdo</h3><p>Publicação de obras, digitalização, catalogação e distribuição de acervos com licenciamento corporativo.</p></article>
          <article className="solution-card"><span className="portfolio-index">03 / TECNOLOGIA</span><h3>Software e educação</h3><p>Plataformas sob demanda, ensino digital, automação de processos e infraestrutura de dados.</p></article>
        </div>
      </section>

      <section className="portfolio-section" aria-labelledby="portfolio-heading">
        <div className="section-heading"><div><span className="portfolio-label">Nosso portfólio</span><h2 id="portfolio-heading">Serviços e clientes</h2></div></div>
        <div className="portfolio-grid">
          <div className="portfolio-column">
            <article className="portfolio-card">
              <h3>Desenvolvimento de IA para gestão comercial</h3>
              <p className="text-muted">Conteúdo instrucional e desenvolvimento de 48 prompts e skills de IA aplicados às seis dimensões da gestão comercial. Materiais orientados à formação de equipes e ao uso de inteligência artificial nas rotinas de análise, planejamento e gestão.</p>
              <p><strong>Cliente:</strong> <a href="https://fecomercio-go.portaldocomercio.org.br/">Fecomércio GO</a></p>
              <div className="portfolio-card__logo"><img src="/logos/fecomercio-go.png" alt="Fecomércio GO" /></div>
            </article>
            <article className="portfolio-card">
              <h3>Laudos periciais e valuations de software</h3>
              <p className="text-muted">Elaboração de laudos periciais e valuations de software, com análise técnica e organização de evidências para fundamentar a avaliação de ativos digitais. Documentação estruturada para apoiar decisões institucionais e a compreensão do valor tecnológico das soluções.</p>
              <p><strong>Cliente:</strong> <a href="https://aroeira.org.br">Fundação Aroeira</a></p>
              <div className="portfolio-card__logo portfolio-card__logo--aroeira"><img src="/logos/aroeira.png" alt="Fundação Aroeira" /></div>
            </article>
            <article className="portfolio-card">
              <h3>Material de treinamento em tecnologia e gestão</h3>
              <p className="text-muted">Desenvolvimento de conteúdo e ebooks para treinamento técnico em tecnologia e gestão de projetos, com organização didática e aplicação às rotinas profissionais. Materiais que podem integrar trilhas de ensino digital e capacitação de equipes no uso de ferramentas, planejamento e acompanhamento de projetos.</p>
              <p><strong>Cliente:</strong> <a href="https://sosdocs.com.br/">SOS Docs</a></p>
              <div className="portfolio-card__logo"><img src="/logos/sosdocs.png" alt="SOS Docs" /></div>
            </article>
          </div>
          <div className="portfolio-column">
            <article className="portfolio-card">
              <h3>Obras técnicas e materiais instrucionais</h3>
              <p className="text-muted">Produção editorial de obras técnicas e materiais instrucionais, com estruturação didática e organização do conhecimento para formação profissional. Conteúdos preparados para apoiar o ensino e compor acervos educacionais em formatos impressos e digitais, conforme o projeto.</p>
              <p><strong>Cliente:</strong> FTD Educação</p>
              <div className="portfolio-card__logo portfolio-card__logo--ftd"><img src="/logos/ftd.svg" alt="FTD Educação" /></div>
            </article>
            <article className="portfolio-card">
              <h3>Plataforma de ensino EAD e SaaS de gestão educacional</h3>
              <p className="text-muted">Manutenção de plataforma Moodle para ensino a distância e SaaS de gestão educacional. A oferta integra organização de cursos, gestão de turmas e matrículas, acompanhamento da aprendizagem e relatórios para apoiar a operação acadêmica e a formação continuada.</p>
              <p><strong>Cliente:</strong> BrasilPós</p>
              <div className="portfolio-card__logo"><img src="/logos/brasilpos.png" alt="BrasilPós" /></div>
            </article>
            <article className="portfolio-card">
              <h3>SaaS de gestão, dados e acervos artísticos e editoriais</h3>
              <p className="text-muted">Gestão e processamento de dados de acervos artísticos e editoriais como serviço, com organização de obras e informações para consulta e operação. A oferta pode integrar catalogação, digitalização, automação de rotinas e relatórios para ampliar o acesso e apoiar a gestão do patrimônio cultural e documental.</p>
              <p><strong>Cliente:</strong> Banco de Microcrédito e Impacto Social (BIS)</p>
              <div className="portfolio-card__logo"><img src="/logos/bis.png" alt="BIS — Impacto Social" /></div>
            </article>
          </div>
          <div className="portfolio-column">
            <article className="portfolio-card">
              <h3>Desenvolvimento de software sob demanda</h3>
              <p className="text-muted">Desenvolvimento de software sob demanda, para processos e necessidades operacionais da organização. Soluções conectam gestão financeira empresarial, conciliação, folha de pagamento e RH por meio de integrações, automação de rotinas e relatórios gerenciais.</p>
              <p><strong>Cliente:</strong> <a href="https://universalpagamentos.com.br">Universal Pagamentos</a></p>
              <div className="portfolio-card__logo"><img src="/logos/universal-pagamentos.png" alt="Universal Pagamentos" /></div>
            </article>
            <article className="portfolio-card">
              <h3>Curadoria artística-editorial e gestão de acervo</h3>
              <p className="text-muted">Curadoria artística-editorial e seleção de obras para o catálogo “100 anos de Antônio Poteiro”, com organização do acervo e articulação entre imagens e conteúdo. O trabalho pode apoiar a documentação do patrimônio artístico e sua difusão em publicações e acervos digitais.</p>
              <p><strong>Cliente:</strong> <a href="https://www.antoniopoteiro.com.br/">Instituto Antônio Poteiro</a></p>
              <div className="portfolio-card__logo portfolio-card__logo--inverse"><img src="/logos/instituto-antonio-poteiro.png" alt="Instituto Antônio Poteiro" /></div>
            </article>
            <article className="portfolio-card">
              <h3>Plataforma e conteúdo instrucional</h3>
              <p className="text-muted">Plataforma e conteúdo instrucional para WebManager, abrangendo os módulos Contabilidade e Contas a Pagar e o Guia de Parametrização. Organização do conhecimento operacional para capacitar usuários, apoiar a configuração do sistema e orientar as rotinas contábeis e financeiras.</p>
              <p><strong>Cliente:</strong> <a href="https://www.mxm.com.br/">MXM Sistemas e Serviços de Informática S/A</a></p>
              <div className="portfolio-card__logo portfolio-card__logo--inverse"><img src="/logos/mxm.png" alt="MXM Sistemas" /></div>
            </article>
          </div>
        </div>
      </section>

      <RuleOrnament />

      <section className="portfolio-section" aria-labelledby="projects-heading">
        <div className="section-heading">
          <div><span className="portfolio-label">Soluções para instituições</span><h2 id="projects-heading">Uma base tecnológica. Diferentes instituições.</h2></div>
        </div>
        <p className="text-muted portfolio-intro">Frentes e oportunidades em desenvolvimento, com implantação conforme o escopo de cada projeto.</p>
        <div className="project-list">
          {projectAreas.map((area) => (
            <article className="project-row" key={area.number}>
              <span className="project-row__number" aria-hidden="true">{area.number}</span>
              <div><span className="portfolio-label">{area.partners}</span><h3>{area.title}</h3></div>
              <div><p>{area.description}</p><span className="project-row__capabilities">{area.capabilities}</span></div>
            </article>
          ))}
        </div>
      </section>

      <section className="portfolio-cta" aria-labelledby="catalog-heading">
        <div><span className="portfolio-label">DataSci Editora</span><h2 id="catalog-heading">Conhecimento que acompanha o seu trabalho.</h2><p>Explore nossas obras técnicas e acadêmicas, coleções e licenças para equipes.</p></div>
        <Link to="/catalogo" className="btn">Explorar catálogo <span aria-hidden="true">→</span></Link>
      </section>
    </div>
  );
}
